import React, {useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import clsx from 'clsx';
import Alert from  '../../Components/Alert';
import Tabela from './Tabela'
import './css/Agenda.css';
import moment from 'moment'

const useStyles = makeStyles((theme) => ({
  paper: {
    boxShadow: "0px 0x 0px 0px gray",
    borderRadius: "0px",
  },
  colorPaper: {
    backgroundColor: "#f9f9f9",
  },
  container: {
    // margin: "4rem 0 6rem 0",
    // paddingTop: "1.5rem"
    marginTop: '4rem'
  },
  containerClinic: {
    margin: "0rem 0 6rem 0",
    paddingTop: "1.5rem"
  }

}));

export default function SpacingGrid() {
  const classes = useStyles();
  

const date = new Date()
const newDate = moment(date).format('DD/MM/YYYY, h:mm:ss a')


  useEffect(() => {
    // window.alert(newDate)
    localStorage.removeItem('patientID')
    localStorage.removeItem('agendamentoId')
  }, [])

  return (
    <div className={localStorage.getItem('containerClass')}>
      <Alert/>
      <Tabela/>
  </div>
  );
}